import Image from "next/image";

import ScreenshotIntelligence from "./images/intelligence-overview.png";
import ScreenshotMarketTrends from "./images/intelligence-trends.png";
import ScreenshotBenchmark from "./images/intelligence-benchmark.png";
import {
  FeatureCard,
  DescriptionCard,
  Descriptions,
  DescriptionTitle,
  Heading,
  ImageFrame,
} from "./feature";
import { Feature } from "./feature";

export const Feature3 = () => {
  return (
    <Feature>
      <Heading>
        Make the best decisions by comparing
        <br
          css={`
            display: none;

            @media (min-width: 960px) {
              display: block;
            }
          `}
        />{" "}
        your cases with Lawfully Intelligence
      </Heading>

      <FeatureCard
        title="Lawfully Intelligence"
        description="Get actionable insights from market trends and benchmark your cases to make data-driven decisions"
        color="#E0F2FE"
        link={{
          href: "https://www.lawfully.com/intelligence",
          label: "Explore Lawfully Intelligence",
        }}
        image={
          <Image
            src={ScreenshotIntelligence}
            alt="Lawfully Intelligence"
            width={1713}
            height={1028}
            unoptimized={!!process.env.NEXT_PUBLIC_NETLIFY}
          />
        }
      />

      <Descriptions>
        <DescriptionCard>
          <div
            css={`
              display: flex;
              flex-direction: column;
              gap: 12px;

              @media (min-width: 960px) {
                gap: 0;
              }
            `}
          >
            <DescriptionTitle title="Market Trends" />
            <div
              css={`
                display: flex;
                padding: 0 15px;

                @media (min-width: 960px) {
                  transform: scale(1.6);
                  /* Anchor top-right so the card title stays visible and the
                     ImageFrame shadow shows on the top-right; the zoom bleeds
                     off the bottom-left (cropped by the card). */
                  transform-origin: right top;
                }
              `}
            >
              <ImageFrame>
                <Image
                  src={ScreenshotMarketTrends}
                  alt="Market Trends"
                  width={2200}
                  height={1075}
                  unoptimized={!!process.env.NEXT_PUBLIC_NETLIFY}
                />
              </ImageFrame>
            </div>
          </div>
        </DescriptionCard>

        <DescriptionCard>
          <div
            css={`
              display: flex;
              flex-direction: column;
              gap: 20px;

              @media (min-width: 960px) {
                gap: 0;
              }
            `}
          >
            <DescriptionTitle title="Benchmark" />
            <div
              css={`
                display: flex;
                padding: 0 0 0 42px;
              `}
            >
              <ImageFrame>
                <Image
                  src={ScreenshotBenchmark}
                  alt="Benchmark"
                  width={1712}
                  height={1136}
                  unoptimized={!!process.env.NEXT_PUBLIC_NETLIFY}
                />
              </ImageFrame>
            </div>
          </div>
        </DescriptionCard>
      </Descriptions>
    </Feature>
  );
};
